<template>
  <b-modal
    ref="codificationSearcherModal"
    centered
    modal-class="codification-searcher-modal"
    @hidden="hide"
  >
    <div slot="modal-title">
      <span>{{ $t('configuration.actions.codificationSearcher') }}</span>
    </div>
    <b-row class="pt-2 pb-3 px-3">
      <b-col>
        Content here
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            size="sm"
            class="btn--primary"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $t('configuration.actions.add') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>

export default {
    name: 'CodificationSearcherModal',
    props: {
        actionTitle: String
    },
    data() {
        return {
            status: null,
            internalCountry: {}
        }
    },
    methods: {
        show() {
            this.$refs.codificationSearcherModal.show()
        },
        hide() {
            this.$refs.codificationSearcherModal.hide()
        }
    }
}
</script>

<style lang="scss">
    .codification-searcher-modal .modal-dialog {
        max-width: 80% !important;
    }
    .codification-searcher-modal .modal-body {
        height: 600px !important;
    }
</style>

<style lang="scss" scoped>
</style>
